// Generated with AI Coding Rules Hub
import { EXTERNAL_ID_SESSION_STORAGE_KEY } from '@cof/refi-web-sdk/dist/utils/stratum';
import { REFI_MFE_UUID } from '@cof/refi-web-sdk';
import { DebugService } from '../../../shared/services/debug.service.js';
import { REFI_ESIGN_CONST } from '../../../../constants/app.constants.js';
import { getIsV2Routing } from '../../../shared/services/routing-v2.service.js';

class _SessionService {
  constructor() {
    this.debug = new DebugService('SessionService');
    this._isMockSession = false;
    this.refreshSession();
  }

  refreshSession() {
    this.sessionStorageKey = REFI_ESIGN_CONST.REFI_SESSION_KEY;
    this.sessionStorageKeyV2 = REFI_ESIGN_CONST.REFI_SESSION_KEY_V2;
    if (getIsV2Routing()) {
      this._session = JSON.parse(sessionStorage.getItem(this.sessionStorageKeyV2))?.state?.currentSession;
    } else {
      this._session = JSON.parse(sessionStorage.getItem(this.sessionStorageKey));
    }

    this._pfci = sessionStorage.getItem(REFI_ESIGN_CONST.REFI_PI_KEY) === '1';
  }

  get session() {
    if (getIsV2Routing()) {
      this._session = JSON.parse(sessionStorage.getItem(this.sessionStorageKeyV2))?.state?.currentSession || { currentApp: {}, eAppId: null };
    } else {
      this._session = JSON.parse(sessionStorage.getItem(this.sessionStorageKey));
    }
    // Mitigation (CWE-639 IDOR): eAppId is client-controlled (session storage) and is
    // forwarded to the ESIGN BFF with no server-side ownership check in this repo. Reject
    // structurally-invalid identifiers (path-traversal, non-numeric, oversized) at this
    // single choke point so malformed ids never reach any BFF caller. A plain numeric id
    // of up to 15 digits is the only accepted shape. NOTE: this does NOT replace the
    // terminal server-side ownership verification, which lives in the ESIGN BFF.
    if (this._session && this._session.eAppId != null && !/^[a-zA-Z0-9]{1,15}$/.test(String(this._session.eAppId))) {
      this.debug.error('Rejecting malformed eAppId to mitigate IDOR (CWE-639)', this._session.eAppId);
      this._session.eAppId = null;
    }
    this.debug.log('getting session', this._session);
    return this._session;
  }

  get mockSession() {
    this._session = {
      eAppId: '123645364',
      borrowerInfo: {
        firstName: 'John',
        lastName: 'Doe',
      },
      currentApp: {
        firstName: 'John',
        lastName: 'Doe',
        appId: 234,
        statFlag: 61,
        appStatusId: 405,
        validityEndDate: '2024-10-20T21:12:07.397Z',
      },
    };
    this._isMockSession = true;
    return this._session;
  }

  get isMockSession() {
    return this._isMockSession;
  }

  set session({ appStatusId, statFlag }) {
    if (getIsV2Routing()) {
      const appStore = JSON.parse(sessionStorage.getItem(this.sessionStorageKeyV2));
      if (!this._session?.currentApp) {
        this._session.currentApp = {};
      }
      Object.assign(this._session.currentApp, { appStatusId, statFlag });
      appStore.state.currentSession = this._session;
      sessionStorage.setItem(this.sessionStorageKeyV2, JSON.stringify(appStore));
      document.dispatchEvent(new CustomEvent('update-app-store'));
    } else {
      if (!this._session?.currentApp) {
        this._session = JSON.parse(sessionStorage.getItem(this.sessionStorageKey));
      }
      Object.assign(this._session.currentApp, { appStatusId, statFlag });
      sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(this._session));
    }
  }

  get pfci() {
    this.debug.log('getting pfci', this._pfci);
    return this._pfci;
  }

  getExternalId() {
    return sessionStorage.getItem(EXTERNAL_ID_SESSION_STORAGE_KEY);
  }

  setReferrerId() {
    if (getIsV2Routing()) {
      const appStore = JSON.parse(sessionStorage.getItem(this.sessionStorageKeyV2));
      appStore.currentSession.referrerId = REFI_MFE_UUID.REFI_APPLY;
      sessionStorage.setItem(this.sessionStorageKeyV2, JSON.stringify(appStore));
      document.dispatchEvent(new CustomEvent('update-app-store'));
    } else {
      this._session.referrerId = REFI_MFE_UUID.REFI_APPLY;
      sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(this._session));
    }
  }

  removeSession() {
    this.debug.log('removeSession');
    if (getIsV2Routing()) {
      sessionStorage.removeItem(this.sessionStorageKeyV2);
    } else {
      sessionStorage.removeItem(this.sessionStorageKey);
    }
  }
}

export const SessionService = new _SessionService();
